import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'Components';
import './DateField.css';

const DateField = ({
  title, required, ...rest
}) => (
  <div className="date-field">
    {
      title &&
      <div className="date-field__title">
        {title}
        { required && <span className="date-field__required">*</span> }
      </div>
    }
    <Input type="date" required={required} {...rest} />
  </div>
);

DateField.propTypes = {
  title: PropTypes.string,
  required: PropTypes.bool,
};

export default DateField;



// WEBPACK FOOTER //
// ./src/components/DateField/DateField.jsx